export const cardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px 20px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.default,
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: ({ palette }) => palette.text.secondary,
};

export const headerIconStyles = {
  display: 'flex',
  flexShrink: 0,
};

export const headerTitleStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const columnsStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: '20px',
  '@media (max-width: 720px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
};

export const columnStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const columnLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const columnNoteStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: ({ palette }) => palette.text.secondary,
};

export const lockNoteIconStyles = {
  display: 'flex',
  flexShrink: 0,
  color: ({ palette }) => palette.text.secondary,
};
